const imgurl = "https://healthcare.medleymed.com"; // Defalut Image url
module.exports = {
  siteurl: "https://healthcare.medleymed.com:8080/",
  //siteurl: "https://telemedicine.medleymed.com:8080/",
  //siteurl: "http://localhost:8080/",
  timezone: "Asia/Kolkata",
  timeOffset: 330,
  //imgurl: "https://padmaclinicstaging.medleymed.com",
  imgurl: "https://healthcare.medleymed.com",
  //imgurl: "http://localhost:3000",
  // imgurl: (function () {
  //   if (typeof window !== "undefined") {
  //     let url = window.location.host;
  //     if (url == "localhost:3000") {
  //       return "http://localhost:3000";
  //     } else if (url == "sunshinestaging.medleymed.com") {
  //       return "https://sunshinestaging.medleymed.com";
  //     } else {
  //       return "https://sunshinestaging.medleymed.com";
  //     }
  //   }
  // })(),
  //paymentkey: "pk_test_b503e67b2f26e761101121c9704e9e06bc4c5b79",
  paymentkey: "pk_test_50c4105c8a980c18302dc1abddf4278c31af1fe8",
  gokadaApiKey:
    "JtkvzUjr2Dt9osSRPotebKqrhvPZNTqHQc0Ric4djNB0r8DHWGZ7NIIqoXRM_test",
  //sendername: "Padma Clinic",
  sendername: "MedleyMed ",
  senderEmail: "team.sanar@gmail.com",
  currency: "₹",
  countryID: "101",
  stateId: "36",
  // Paytm keys
  // paytm_mid: "KwRQVt65865982291013",
  // paytm_merchantKey:"1usZCfZTfQWQiH#z",
  Paytm_callBackURL: "api/PatientAppointment/TelemedicePaytmPaymentSuccess",
  Paytm_orderMedicineCallBackURL: "api/OM/orderProcess/OrderMedicinePaytmPayment                                                                             Success",
  /* for Staging */
  Paytm_hostname: 'securegw-stage.paytm.in',
  // Paytm keys
  paytm_mid: "KwRQVt65865982291013",
  paytm_merchantKey: "1usZCfZTfQWQiH#z",
  /* for Production */
  // Paytm_hostname: 'securegw.paytm.in'
  //Paytm_hostname: 'securegw.paytm.in',
  // Paytm keys
  //paytm_mid: "UvCRif08464633111500",
  //paytm_merchantKey:"@9HGTx7G%OwHHCO_",

  // Appointment waiting time for consult now
  appointmentWaitingTime: 0,

  // PDf image base url
  imgHostUrl: "file:///var/MultiModules/public",

  // Video call domain and Jwt token
  jitsiDomain: "videovisit.medleymed.com",
  jitsiJwt: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJjb250ZXh0Ijp7InVzZXIiOnt9fS                                                                             wiYXVkIjoidmlkZW92aXNpdC5tZWRsZXltZWQuY29tIiwiaXNzIjoiTWVkRG9jTWFzdGVyQXBwSUQiLC                                                                             JzdWIiOiJ2aWRlb3Zpc2l0Lm1lZGxleW1lZC5jb20iLCJyb29tIjoiKiJ9.tmoZKAHyrB94Ir2j0cXz1                                                                             Jop52b1OA91vimQ5fBpejo',

  // APi key for Lat,langs
  //googleAPiKey:"AIzaSyAhM9f13JS3erSaJ0gAeQm8w0KcMfcIopU",
  //googleAPiKey: "AIzaSyCJvEQmWCo1HL1eOePHbjUbK_Wd7LlJkMs",
  googleAPiKey: "AIzaSyA8DX2hscBm1X1ZJc07d4cMb5dQ9u3HdII",


  //consult now appointment duriation
  doctorSlotDuration: "00:15", //HH:mm
  //cancellation duration for PatientAppointment
  orderCancelationTime: "00:05",  //HH:mm
  retailerWallertMiniumpoints: 50,

  // Payment Gateway
  //razorpay_key_id: 'rzp_test_gIIAc42lIE8qma', // Test YOUR RAZORPAY KEY
  //razorpay_key_secret: 'olET4WyhaaB0gvRtvcTu2HIF', // Test YOUR RAZORPAY SECRE                                                                             T


  razorpay_key_id: 'rzp_live_TGuKKeFvgF5flZ', //live keys
   razorpay_key_secret: '0PbpKLo15vvwsICKz90GEBdl', //live secret
  //razorpay_key_id: 'rzp_test_RIiT6vkP9Z56V4',
  //razorpay_key_secret: 'ak1EnUawg0a5XBkCP22ZMe3Y',


  //One signal keys

  doctorRestKey: 'YWFiYzZiNGYtYTU3MS00Y2FlLWI1NzItYzE4NjU2NDRmZmY4',
  doctorAppID: 'a60602d0-43da-45e3-ab15-34ab47ee0ad8',

  patientRestKey: "NzkwMDljYWEtOWRjMC00YTI3LTliNjYtY2FjNDlmMWZiZmQ2",
  patientAppID: "038a8888-8e8b-4231-abf9-6a9e11ba05a7",

  // one signal channel id
  doctorAppointmentchannelID: "6c5c77a6-e0ef-402b-9fb5-b0f251625864",
  patientAppointmentchannelID: "5021d390-4e70-46e4-a14c-c90bf209d6e7",
  RemainderchannelID: "30fb2a31-6a2b-40cf-9c58-0a2f53e52ebe",

  defaultSubscriptionId: "1",
  EveryReminderTimeset: 5,
  UptoReminderTimeset: 30,
  RemainderTimeSlotDifference: 30,
  AWS_ACCESS_KEY_ID:"AKIA43KPUWGM2727CE25",
  AWS_SECRET_ACCESS_KEY:"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",
  AWS_BUCKET_NAME:"b2c-multimodules-uploads",
  AWS_REGION:"ap-south-1",
  QUICK_DELIVERY_TIME:"2 to 3 hrs",
  STANDARD_DELIVERY_TIME:"4 to 6 hrs",
  DEFAULT_PRODUCT_IMAGE: imgurl + "/uploads/product_master/default-medicine.png"                                                                             ,
  MSG91_AUTHKEY:"473342AtYTXiGBUw68efa26dP1",
  SEARCH_RADIUS:2,

TOOKAN_API_KEY: "51666282f7420c021542736e545463471becc0fb2bd47e3e5a1e00c9",

};
